import React from 'react';
import ParallaxElement from '../common/ParallaxElement';
import Puff from './Puff';

export default class DiscoverKingdom extends React.PureComponent {
    static propTypes = {};
    render() {
        return (
            <div className="discover-kingdom">
                <div className="background" />
                <div className="content">
                    <h1>Discover The Kingdom</h1>
                    <p>Monsters have infested every corner of the kingdom, from ice sheets and lava
                        fields to ancient forests and sheer mountains.
                    </p>
                </div>
                <ParallaxElement yStrength={0.2} id="puff">
                    <Puff />
                </ParallaxElement>
            </div>
        );
    }
}

